import React from "react";
import { useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import Login from "./login";
import { useFormSubmission } from "@hooks";
import PropTypes from 'prop-types';

const SetupLogin = ({ initial, success }) => {

    const { setSpinnerShow } = useSpinnerContext();
    const { email } = initial;

    const { setFormState, hasFormError, formError } = useFormSubmission();

    const handleSubmit = async (values) => {

        setSpinnerShow(true);
        try {
            await sunboundPayProxy.login(values.email, values.password);
            success();
        } catch (error) {
            console.log(error);
            setFormState(`Login failed`);
        }
        setSpinnerShow(false);
    };

    return (
        <>
            <Login submit={handleSubmit} initial={{ email }}>
                <h1 className="text-2xl font-semibold leading-6 text-gray-900 tracking-wide">Login to continue account setup</h1>
            </Login>
            {
                hasFormError &&
                <p className="text-red-600 text-xl">{formError}</p>
            }
        </>
    );

};

SetupLogin.propTypes = {
    initial: PropTypes.object,
    success: PropTypes.func
};

export default SetupLogin;